<template>
  <v-navigation-drawer    
    persistent
    id="LeftDrawer"
    :mini-variant="miniVariant"
    :clipped="clipped"
    v-model="drawer"
    enable-resize-watcher                
    :dark="$vuetify.dark"       
    width="260"
    fixed
    app
    >
    
    <v-toolbar :color="color+' darken-1'" dark dense>
      <img src="@/assets/img/m.png" height="36" alt="Vue Material Admin Template">
      <v-toolbar-title class="ml-0 pl-3">
        <span class="hidden-sm-and-down">{{ title }}</span>
      </v-toolbar-title>        
    </v-toolbar>      
    <!--<div class="v-card v-card--flat v-card--tile" style="position: absolute">
        <div data-v-d9e5aed4="" class="v-card__media">
            <div class="v-card__media__content">
                <img src="@/assets/img/bg/16.jpg" style="height:150px" alt="">
            </div>
        </div> 
    </div>    
    <v-toolbar flat class="transparent" style="margin-top:90px">                    
        <v-list class="pa-0" >            
          <v-list-tile avatar @click="dialog = !dialog">
            <v-list-tile-avatar>
              <img src="@/assets/img/avatar/man_4.jpg">
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title style="color:#fff">{{username}}</v-list-tile-title>
              <small style="color:#2AFF2A"><v-icon color="green">fa-circle</v-icon> online</small>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>-->
    <div id="left-scroll">      
      <v-list dense expand>
        <template v-for="(item, i) in menus">
            <!--group with subitems-->
            <v-list-group v-if="item.items && item.visible" :key="item.name" :group="item.group" :prepend-icon="item.icon" no-action="no-action">
              <v-list-tile slot="activator" ripple="ripple">
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <template v-for="(subItem, i) in item.items">
                <!--sub group-->
                <v-list-group v-if="subItem.items" :key="subItem.name" :group="subItem.group" sub-group="sub-group">
                  <v-list-tile slot="activator" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-for="(grand, i) in subItem.children" :key="i" :to="genChildTarget(item, grand)" :href="grand.href" ripple="ripple">
                    <v-list-tile-action v-if="grand.icon">
                        <v-icon>{{ grand.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>
                <!--child item-->
                <v-list-tile v-else-if="subItem.visible" :key="i" :to="genChildTarget(item, subItem)" :href="subItem.href" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple">
                  <v-list-tile-content>
                    <v-list-tile-title><span>{{ subItem.title }}</span></v-list-tile-title>
                  </v-list-tile-content>
                  <!-- <v-circle class="white--text pa-0 circle-pill" v-if="subItem.badge" color="red" disabled="disabled">{{ subItem.badge }}</v-circle> -->
                  <v-list-tile-action v-if="subItem.action">
                    <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list-group>
            <v-subheader v-else-if="item.header && item.visible" :key="i">{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider && item.visible" :key="i"></v-divider>
            <!--top-level link-->
            <v-list-tile v-else-if="item.visible" :to="!item.href ? { name: item.name } : null" :href="item.href" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="item.name">
              <v-list-tile-action v-if="item.icon">
                <v-icon>{{item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
              <!-- <v-circle class="white--text pa-0 chip--x-small" v-if="item.badge" :color="item.color || 'primary'" disabled="disabled">{{ item.badge }}</v-circle> -->
              <v-list-tile-action v-if="item.subAction">
                <v-icon class="success--text">{{ item.subAction }}</v-icon>
              </v-list-tile-action>
              <!-- <v-circle class="caption blue lighten-2 white--text mx-0" v-else-if="item.chip" label="label" small="small">{{ item.chip }}</v-circle> -->
            </v-list-tile>
        </template>
        
        
      </v-list>            
    </div>
    <v-dialog v-model="dialog" scrollable max-width="300px">
      
      <v-card>
        <v-card-title>Select Branch</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <v-radio-group v-model="orgn_id" column>
            <v-radio v-for="(item, index) in orgns" :label="item.name" :value="item.id" v-bind:key="index"></v-radio>            
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>         
        </v-card-actions>
      </v-card>
    </v-dialog>    
  </v-navigation-drawer>
</template>
<script>
import config from '@/config'  
let menu = require('@/apps/'+config.apps+'/router/navmenu');

export default {
  name: 'app-left-drawer',
  components: {
    
  },
  props: {
    expanded: {
      type: Boolean,
      default: true
    },
  },
  data: () => ({
    dialog: false,
    online : false,  
    title : config.title,
    color: config.color,
    username : null,
    miniVariant:false,
    clipped :false,
    mini: false,
    drawer: true,    
    orgns: [],
    scrollSettings: {
      maxScrollbarLength: 60
    },
    formModel :{
       user_id : null,       
    },
    orgn_id : null,
  }),  
  computed: {
    computeGroupActive () {
      return true;
    },    
    sideToolbarColor () {
      return this.$vuetify.options.extra.sideNav;
    },
    menus(){
      
      return menu.default();
    }
  },
  created () {    
    window.getApp.$on('APP_LEFT_DRAWER_TOGGLED', () => {
      this.drawer = (!this.drawer);
    });
    window.getApp.$on('APP_LEFT_MINI_VARIANT', () => {
      this.miniVariant = (!this.miniVariant);
    });
    window.getApp.$on('APP_LEFT_CLIPPED', () => {
      this.clipped = (!this.clipped);
    });
    window.setInterval(function(){
        this.online = navigator.onLine;
    }, 1000);    
  },
  

  methods: {
    genChildTarget (item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component,
        };
      }
      if(!subItem.name){
        return { name: `${item.group}` };
      } else {
        if(item.group){
          return { name: `${item.group}/${(subItem.name)}` };
        } else {
          return { name: `${(subItem.name)}` };
        }
      }
      
    },
    scrollHanle(/*evt*/) {
      
    },       
  }
};
</script>
<style lang="stylus">
  #left-scroll{
      height: calc(100vh - 64px);
      overflow: auto;
  }  
</style>
